import SlideAPI from '@/api/slide'
import AudienceAPI from '@/api/audience'
import ReactionAPI from '@/api/reaction'
import SlideOptionApi from '@/api/slide-option'
import ChatApi from '@/api/chat'
import QuestionApi from '@/api/question'
import UserApi from '@/api/user'
import PrivateFeedbackApi from '@/api/private-feedback'
import Answers from '@/api/answers'
import LeaderboardApi from '@/api/leaderboard'
import AttendedPresentationsApi from '@/api/attended-presentations'
import { initResources as kvSyncApiInitResources } from '@/api/kvSync'
import participantInfo from '@/api/participant-info'
import UploadLogApi from '@/api/upload-log'
import LiveCertificateApi from '@/api/live-certificate'
import presentationAttribute from './presentation-attribute'
import selfPacedAttempt from './self-paced-attempt'
import counting from './counting'
import presenterMilestones from './presenter-milestones'

const initResources = () => {
  SlideAPI.initResource()
  AudienceAPI.initResource()
  ReactionAPI.initResource()
  SlideOptionApi.initResource()
  ChatApi.initResource()
  QuestionApi.initResource()
  UserApi.initResource()
  PrivateFeedbackApi.initResource()
  Answers.initResource()
  LeaderboardApi.initResource()
  AttendedPresentationsApi.initResource()
  kvSyncApiInitResources()
  presentationAttribute.initResource()
  selfPacedAttempt.initResource()
  participantInfo.initResource()
  counting.initResource()
  UploadLogApi.initResource()
  LiveCertificateApi.initResource()
  presenterMilestones.initResource()
}

export default {
  initResources,
}
